import { css } from '@emotion/react';
import { COLOR_PALETTE, Text } from '@inflearn/ds-react';
import { Trans, useTranslation } from 'next-i18next';
import Link from 'next/link';

import { AUTH_URL, INFLEARN_APP_LINK, RALLIT_URL } from '../../../constants/urls';
import { useIsWebview } from '../../../hooks/useIsWebview';
import { useWebviewThemeParameter } from '../../../lib/useThemeParamter';

const URLS = {
  INTEGRATED_ACCOUNT_POLICY: {
    title: '통합회원',
    getHref: AUTH_URL.INTEGRATED_ACCOUNT_POLICY,
    deeplink: INFLEARN_APP_LINK.INTEGRATED_TERMS,
  },
  INFLEARN_TERMS: {
    title: '인프런',
    getHref: AUTH_URL.INFLEARN_TERMS,
    deeplink: INFLEARN_APP_LINK.TERMS,
  },
  RALLIT_TERMS: {
    title: '랠릿',
    getHref: RALLIT_URL.RALLIT_TERMS,
    deeplink: '',
  },
  INFLEARN_PRIVACY: {
    title: '개인정보 처리방침',
    getHref: AUTH_URL.INFLEARN_PRIVACY,
    deeplink: INFLEARN_APP_LINK.PRIVACY_POLICY,
  },
} as const;

export const SignupDescription = () => {
  const { t } = useTranslation();
  const isWebview = useIsWebview();
  const { isDarkTheme } = useWebviewThemeParameter();

  return (
    <Text align="center" size="xs" color={isDarkTheme ? darkThemeStyle.desc.color : 'gray.6'}>
      <Trans
        i18nKey="해당 계정은 통합회원으로 인프런과 랠릿에서"
        components={{
          IntegratedAccount: (
            <DescriptionHyperLink
              href={
                isWebview
                  ? URLS.INTEGRATED_ACCOUNT_POLICY.deeplink
                  : URLS.INTEGRATED_ACCOUNT_POLICY.getHref()
              }
              text={t(URLS.INTEGRATED_ACCOUNT_POLICY.title)}
            />
          ),
          InflearnTerms: (
            <DescriptionHyperLink
              href={isWebview ? URLS.INFLEARN_TERMS.deeplink : URLS.INFLEARN_TERMS.getHref()}
              text={t(URLS.INFLEARN_TERMS.title)}
            />
          ),
          RallitTerms: (
            <DescriptionHyperLink
              href={isWebview ? URLS.RALLIT_TERMS.deeplink : URLS.RALLIT_TERMS.getHref()}
              text={t(URLS.RALLIT_TERMS.title)}
            />
          ),
          Privacy: (
            <DescriptionHyperLink
              href={isWebview ? URLS.INFLEARN_PRIVACY.deeplink : URLS.INFLEARN_PRIVACY.getHref()}
              text={t(URLS.INFLEARN_PRIVACY.title)}
            />
          ),
        }}
      />
    </Text>
  );
};

const DescriptionHyperLink = ({ href, text }: { href: string; text: string }) => (
  <Link href={href} target="_blank" css={styleHyperLink}>
    {text}
  </Link>
);

const styleHyperLink = css({
  color: COLOR_PALETTE.blue[7],
});

export const darkThemeStyle = {
  desc: {
    color: 'dark.2',
  },
};
